// HomeWeb.jsx
import React, { useState, useRef, useEffect } from 'react';
import { Text, ScrollView, View, Image, TouchableOpacity, Platform, TouchableWithoutFeedback, TextInput, KeyboardAvoidingView, Alert } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import BaseWeb from '../../components/baseWeb';
import styles from '../../styles/formularios';
import axios from 'axios';
import MaskInput, { Masks } from 'react-native-mask-input'; // Para aplicar máscara no CPF
export default function DadosTestemunhasCorretagemWeb({ route }) {
  const navigation = useNavigation();
  // envio unico 

  // const [usuario_id, setUsuario_id] = useState(null);
  const { payload_corretores, endereco_imovel, usuario_id, email_solicitante } = route.params || {};

  console.log("Dados recebidos:", payload_corretores, endereco_imovel, usuario_id)
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loading, setLoading] = useState(false);
  const [testemunhas, setTestemunhas] = useState([
    { nome: '', rg: '', cpf: '' },
    { nome: '', rg: '', cpf: '' },
  ]);

  const atualizarTestemunha = (index, campo, valor) => {
    const novas = [...testemunhas];
    novas[index][campo] = valor;
    setTestemunhas(novas);
  };

  const isFormValid = () => {
    return testemunhas.every((t) => t.nome && t.rg && t.cpf);
  };

  const handleSalvar = async () => {
    if (!isFormValid()) {
      Alert.alert('Erro', 'Preencha todos os campos obrigatórios.');
      return;
    }

    if (isSubmitting) return;

    setIsSubmitting(true);
    setLoading(true);

    const testemunhasFormatadas = testemunhas.map((t) => ({
      nome: t.nome,
      rg: t.rg,
      cpf: t.cpf,
    }));

    const payloadCompleto = {
      ...payload_corretores,
      testemunhas: testemunhasFormatadas,
    };

    try {
      const response = await axios.post(
        'https://docx.imogo.com.br/gerar-pdf/contrato-corretagem',
        payloadCompleto
      );
      console.log("Enviado payload: ", payloadCompleto)

      if (response.status === 200 && response.data?.pdf_name) {
        console.log("documento criado!")
        const { pdf_name, docx_url, pdf_url } = response.data;


        const payload_email = {
          email: email_solicitante,
          endereco: endereco_imovel,
          nome_cliente: payload_corretores.contratantes[0]?.nome || "Cliente",
          link_word: docx_url,
          link_pdf: pdf_url
        };

        await axios.post(
          "https://smtp.josuejuca.com/imogo/emails/gerador-de-documentos/corretagem",
          payload_email
        );
        navigation.navigate("BaixarDocGeradorWeb", { usuario_id, imprimir_link_pdf: pdf_url, imprimir_link_docx: docx_url });
      } else {
        Alert.alert("Erro", "Não foi possível gerar o contrato.");
      }
    } catch (error) {
      console.error("Erro ao gerar contrato:", error);
      Alert.alert('Erro', 'Falha ao enviar os dados para a API.');
    } finally {
      setIsSubmitting(false);
      setLoading(false);
    }
  };


  return (
    <BaseWeb>
      {(userInfo) => {
        return (
          <ScrollView contentContainerStyle={styles.contentMinimal}>
            <View style={styles.formContainer}>
              <Text style={styles.title}>Dados das Testemunhas</Text>

              {testemunhas.map((t, index) => (
                <View key={index} style={styles.CorretorContainer}>
                  <View style={styles.row}>
                    <Text style={styles.subLabel}>Nome {index + 1}° Testemunha</Text>
                    <TextInput
                      style={styles.areaInput}
                      placeholder="Nome completo"
                      value={t.nome}
                      onChangeText={(text) => atualizarTestemunha(index, 'nome', text)}
                      placeholderTextColor="#A9A9A9"
                    />
                  </View>

                  <View style={styles.row}>
                    <Text style={styles.subLabel}>RG {index + 1}° Testemunha</Text>
                    <TextInput
                      style={styles.areaInput}
                      placeholder="RG"
                      value={t.rg}
                      onChangeText={(text) => atualizarTestemunha(index, 'rg', text.replace(/\D/g, ''))}
                      placeholderTextColor="#A9A9A9"
                      keyboardType="numeric"
                    />
                  </View>

                  <View style={styles.row}>
                    <Text style={styles.subLabel}>CPF {index + 1}° Testemunha</Text>
                    <MaskInput
                      style={styles.areaInput}
                      value={t.cpf}
                      onChangeText={(text) => atualizarTestemunha(index, 'cpf', text)}
                      mask={Masks.BRL_CPF}
                      placeholder="000.000.000-00"
                      placeholderTextColor="#A9A9A9"
                      keyboardType="numeric"
                    />
                  </View>

                  <View style={styles.divider} />
                </View>
              ))}

              {/* Inputs de Área */}

              {/* Botão Salvar */}
              <View style={styles.buttonContainer}>
                <TouchableOpacity
                  style={[
                    styles.saveButton,
                    (!isFormValid() || isSubmitting) && { backgroundColor: '#ccc' },
                  ]}
                  onPress={handleSalvar}
                  disabled={!isFormValid() || isSubmitting} // Desabilita durante a submissão
                >
                  <Text style={styles.saveButtonText} allowFontScaling={false}>
                    {isSubmitting ? "Enviando..." : "Salvar"}
                  </Text>
                </TouchableOpacity>

                <TouchableOpacity style={styles.laterButton}>
                  <Image
                    source={require('../../../assets/icons/bookmark.png')} // Ícone de terminar mais tarde
                    style={styles.laterIcon}
                  />
                  <Text
                    style={styles.laterButtonText}
                    allowFontScaling={false}
                    onPress={() => navigation.navigate('Home', { usuario_id })}
                  >
                    Terminar mais tarde
                  </Text>
                </TouchableOpacity>
              </View>

            </View>
          </ScrollView>
        );
      }}
    </BaseWeb>
  );
}
